import {MouseEvent, useState} from "react";
import Alert from "react-s-alert";
import {useQueryClient} from "react-query";
import {Button} from "@reside/ui";
import {OrganizationsService} from "../../../services/OrganizationsService";

/**
 * Row above import box containing export button.
 */
export const ExportButton = ({
  /**Id required by export endpoint */
  organizationId,
}: {
  organizationId: string;
}): JSX.Element => {
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const queryClient = useQueryClient();

  const onClickExportFile = async (e: MouseEvent): Promise<void> => {
    e.preventDefault();
    setIsExporting(true);
    try {
      const res = await OrganizationsService.importExportUsers.getOrganizationUsersExport(
        organizationId
      );

      if (res.status === 200) {
        Alert.success("File export initiated successfully");
      } else {
        Alert.error("File export failed. Please try again.");
      }

      setIsExporting(false);
      queryClient.invalidateQueries(["useGetTableData"]);
    } catch (error) {
      Alert.error("An error occurred while exporting the file. Please try again.");
      setIsExporting(false);
    }
  };

  return (
    <Button
      style={{width: "fit-content"}}
      color="primary"
      disabled={isExporting}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        if (isExporting) {
          return;
        }
        onClickExportFile(event);
      }}
    >
      Export
    </Button>
  );
};
